// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import {
    buttonFieldIconClickableStyles,
    buttonFieldIconStyles,
    buttonResetStyles,
} from "@store/Themes/common/mixins/button";
import { ButtonVariant } from "@toolkit/Framework/Types/Button";

export const buttonResetProps: ButtonPresentationProps = {
    color: null as any,
    buttonType: null as any,
    shape: null as any,
    hoverMode: "none",
    activeMode: "none",
    css: buttonResetStyles(false),
};

export const buttonGetFieldIconProps = (
    src: IconPresentationProps["src"],
    variant?: ButtonVariant,
): TextFieldPresentationProps => ({
    iconProps: {
        src,
        css: buttonFieldIconStyles(),
    },
    iconClickableProps: {
        css: buttonFieldIconClickableStyles(variant),
    },
});
